module.exports = __webpack_public_path__ + "img/ie_setting_04_toolbar.7d46adac.jpg";